import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
export const PanelItemDivider = ({ color, thicknessPx = 1, marginPx = 10 }) => {
    const divCss = useMemo(() => css `
      background-color: ${color};
      width: calc(100% - ${marginPx * 2}px);
      height: ${thicknessPx}px;
      min-height: ${thicknessPx}px;
      align-self: center;
    `, [color, thicknessPx, marginPx]);
    return _jsx("div", { css: divCss });
};
